import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import postContactUs from '../../../ApiV2/postContactUs'


let NoMatch = () => {
  const { location } = useParams();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [formStatus, setFormStatus] = useState('Send')
  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setFormStatus('Submitting...');
    let conFom = {
      ContactName: name,
      email: email,
      message: message,
      LocationID: location
    }
    console.log(conFom)

    postContactUs(conFom)
      .then(response => response.status)
      .then(() => {
        setFormStatus('Send');
        setName("");
        setEmail("");
        setMessage("");
        setLoading(false);
      })

      .catch((error) => {
        console.log(error);
        setLoading(false);
      })

  }



  return (
    <>
      

      <div className="background-section">
        <h2 className="mb-3">Were sorry you have not found what you are looking for. </h2>
        <h2 className="mb-3">You have found Vizo Menus. </h2>
        <h2 className="mb-3">If you are looking interested in the future of menus contact us here!</h2>
        <form onSubmit={onSubmit}>
          <div className="mb-3">
            <label className="form-label" htmlFor="name">
              Name
            </label>
            <input className="form-control" type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="email">
              Email
            </label>
            <input className="form-control" type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="message">
              Message
            </label>
            <textarea className="form-control" id="message" value={message} onChange={(e) => setMessage(e.target.value)} required />
          </div>
          <button className="btn btn-primary" disabled={loading} type="submit">
            {formStatus}
          </button>
        </form>
      </div>
    </>
  );
}

export default NoMatch;